import React from "react"
import tw from "twin.macro"
import { TabProps } from "./Tab.d"

const Tab: React.FC<TabProps> = ({ children, ...remainingProps }) => {
  return (
    <div
      css={[
        tw`flex items-end w-full py-5 overflow-x-scroll scrollbar-hide justify-between`,
        tw`md:(flex justify-center items-end flex-wrap pb-4 pt-2 scrollbar-hide)`,
      ]}
      {...remainingProps}
    >
      {children}
    </div>
  )
}

export default Tab
